// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';

import classNames from 'classnames';

import Notify from '../../utils/Notify';

import TextInput from './TextInput';

export default class StringsList extends Component {

  static defaultProps = {
    disabled: false,

    addLabel: I18n.tr('global.add'),
  };

  static propTypes = {
    list: PropTypes.string.isRequired,

    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool,

    addLabel: PropTypes.func,
  };

  get list(): Array<string> {
    return this.props.list;
  }

  onAddClicked = () => {
    let list = this.list;

    list.push('');

    this.props.onChange(list);
  };

  onChange = (text: string, index) => {
    const list = this.list;

    list[index] = text;

    this.props.onChange(list);
  };

  onDelete = (index) => {
    const list = this.list;
    const textToDelete = list[index];

    if (textToDelete.length === 0) { // empty, delete it without asking confirmation
      list.splice(index, 1);
      this.props.onChange(list);
    } else {
      Notify.confirmDelete(I18n.tr('global.are_you_sure'),
       (result) => {
        if (result) {
          list.splice(index, 1);
          this.props.onChange(list);
        }
      });
    }
  };

  //
  // Renderers
  //

  renderStringsList(list: Array<string>) {
    const listView = [];

    _.each(list, (text: string, index) => {
      listView.push(
        <div
          className="input-group"
          style={style.listItem}
          key={index}
        >
          <TextInput
            key={index}
            className="form-control"
            value={text}
            onChange={(text: string) => { this.onChange(text, index); }}
            disabled={this.props.disabled}
          />

          <div className="input-group-addon">
            {!this.props.disabled &&
              <i
                className="fa fa-trash pointer"
                onClick={() => { this.onDelete(index); }}
              />
            }
          </div>
        </div>
      );
    });

    return (listView);
  }

  render() {
    try {
    return (
      <div className="texts_list">
        {this.renderStringsList(this.list)}

        {!this.props.disabled &&
          <div
            style={style.link}
            className="link"
            onClick={this.onAddClicked}
          >
            {this.props.addLabel}
          </div>
        }
      </div>
    );
   } catch (e) { console.error(e); }
  }

}

const style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
